import { render, staticRenderFns } from "./pacs.vue?vue&type=template&id=6ece3b4d&scoped=true&"
import script from "./pacs.vue?vue&type=script&lang=js&"
export * from "./pacs.vue?vue&type=script&lang=js&"
import style0 from "./pacs.vue?vue&type=style&index=0&id=6ece3b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece3b4d",
  null
  
)

export default component.exports